var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m3Hero",style:(_vm.bgImageStyle)},[_c('div',{staticClass:"container",staticStyle:{"max-width":"1000px"}},[_c('h1',{staticClass:"title is-1"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"subtitle is-4"},[_vm._v(_vm._s(_vm.subtitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }